module.exports = __webpack_public_path__ + "img/lock.55fcc6d7.svg";